import { useState, useEffect } from "react";
import axios from "axios"

import EditarMateriais from './components/Editar-cadastro.js';
import ListaMateriais from './components/Grid-materiais-cadastrados';
import ListaSaldos from './components/Grid-saldo-atual.js';
import Cadastrar from './components/Novo-cadastro.js';
import ListaLancamentos from './components/Grid-lancamentos.js';
import Lancamento from './components/Novo-lancamento.js';
import EditarLancamento from './components/Editar-lancamento.js'
import ListaConsumoMes from "./components/Grid-consumo-mes.js";

import GlobalStyle from "../../styles/global-new.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { toast, ToastContainer } from "react-toastify";
import { IoMdArrowBack } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";

import fundo2 from "../../styles/fundo2.svg";
import logo1 from "../../styles/imagem/logo-1.png";
import logo2 from "../../styles/imagem/logo-2.png";
import logo3 from "../../styles/imagem/logo-3.png";
import logo4 from "../../styles/imagem/logo-4.png";
import logo5 from "../../styles/imagem/logo-5.png";


const Div = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;


`;
const Div2 = styled.div`
  background-color: #fff;
  padding: 10px 0px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  h2 {
    color: #575757;
  }
`;

const Div3 = styled.div`
  background-color: #fff;
  padding: 20px 0px 30px 0px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: end;
  gap: 10px;
`;
const DivLayout = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`;

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;

  div{
    width: 100vw;
    border-radius: 10px;
  }
`;

const Title = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  height: 4.0rem;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
const DivButtom = styled.nav`
  width: 100%;
  display: flex;
  justify-content: center; 
  align-items: center;
  height: 4.0rem;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const Title2 = styled.h2`
  display: flex;
  justify-content: space-between; 
  align-items: center;

  color: #008000;
  font-size: 28px;

  @media (max-width: 768px) {
    font-size: 20px;
    width: 90%;
  }

`;

const DivTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center; 
  gap: 25px;
`;



const ButtonSair = styled.button`
  padding: 10px 20px 20px 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  color: #008000;
  height: 45px;
  font-weight: bold;
  font-size: 28px;
  margin: 5px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.2);
  }

`;




const Button = styled.button`
  background-color: #E5F7EE;
  color: #008000;
  font-size: 20px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2;
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
  
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: start; 
`;

const ButtonClose = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  transition: transform 1.5s;
  &:hover {
    transform: scale(1.2);
  }
`;



const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
`;
const ModalContent = styled.div`
  background-image: url(${fundo2});
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh; 
  overflow-y: auto; 
  border-radius: 10px;
  

`;

const Button3 = styled.button`
  padding: 5px 20px;
  background-color: rgba(255, 255, 255, 0.1);
  color: #575757;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  white-space: nowrap; /* ❌ impede quebra de linha */
  display: flex;       /* ✅ ativa flexbox */
  align-items: center; /* ✅ alinha verticalmente */
  justify-content: center; /* ✅ centraliza horizontalmente */
  text-align: center;

  transition: transform 0.2s ease, background-color 0.3s ease;
  gap: 5px;
  &:hover {
    transform: scale(1.1);
    background-color: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    padding: 5px;
    font-size: 14px;
  }
`;

const Input = styled.input`
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Input1 = styled.input`

  width: 200px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
    &.erro {
      border: 2px solid red;
      
    }
`;


const Input2 = styled.input`
  width: auto;
  min-width: 500px;
  padding: 0 10px; /* Adiciona 10px de padding horizontal */
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  box-sizing: border-box; /* Garante que padding não aumente o tamanho total */
`;

const Label = styled.label`
  color: #4f4f4f;
  font-weight: 600;
  font-size: 17px;  
  display: flex;
  flex-direction: column;

  select {
      &.erro {
      border: 2px solid red;
      
    }
  }
`;


const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

const Select = styled.select`
  width: 250px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;


function Usuarios() {

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;

  const token = localStorage.getItem('token');



  //-----------------------------------------------------------------------------------------------------------//

  //Links
  const handleVoltarDash = () => {
    window.location.href = urlFront;
  };
  //-----------------------------------------------------------------------------------------------------------//

  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  const getToken = async () => {
    try {
      const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
      setToken(res.data);
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
        window.location.href = `${urlFront}login`;
      } else {
        console.error("Erro ao obter token:", error);
      }
    }
  };

  useEffect(() => {

    getToken();

  }, [])


  //------------------------------------------TIPO/SUBTIPO MATERIAL-----------------------------------------------------------------//

  const [tipoMaterial, setTipoMaterial] = useState([]);
  const [subTipoMaterial, setSubTipoMaterial] = useState([]);
  const getTipoSubTipo = async () => {
    try {
      const res = await axios.get(`${urlApi}controle-reagentes/tipo-material`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTipoMaterial(res.data);

      const res2 = await axios.get(`${urlApi}controle-reagentes/subtipo-material`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSubTipoMaterial(res2.data);

    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };


  useEffect(() => {
    getTipoSubTipo();
  }, []);

  //------------------------------------------LISTA MATERIAL-----------------------------------------------------------------//

  const [listaMateriais, setListaMateriais] = useState([]);
  const [atualizaMateriais, setAtualizaMateriais] = useState(false);


  // NOVO: controla visibilidade do grid
  const [showMateriais, setShowMateriais] = useState(false);

  const getListaMateriais = async () => {
    try {
      const res = await axios.get(`${urlApi}controle-reagentes/lista-materiais`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setListaMateriais(res.data || []);
      setShowMateriais(true);          // <- mostra grid e oculta botão
      setAtualizaMateriais(false);     // <- reseta flag de atualização
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };

  // Só dispara quando pedirmos atualização (não no mount)
  useEffect(() => {
    if (atualizaMateriais) {
      getListaMateriais();
    }
  }, [atualizaMateriais]);






  //---------------------IMAGEM DE CARREGANDO-----------//
  const [abaAtiva, setAbaAtiva] = useState("consumo");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];

  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000);
  };

  useEffect(() => {
    trocarAbaComImagem("consumo"); // define o nome da aba ativa
  }, []);


  //---------------------------------------MODAL EDITAR DE MATERIAL---------------------------------------------------//
  const [editarMateriais, setEditarmateriais] = useState([])
  const [isModalOpenEditarMateriais, setIsModalOpenEditarMateriais] = useState(false);
  const modalEditarMateriais = (item) => {
    setIsModalOpenEditarMateriais(!isModalOpenEditarMateriais);
    setEditarmateriais(item);

  };

  //---------------------------------------MODAL CADASTRAR MATERIAL---------------------------------------------------//

  const [isModalOpenCadastrarMateriais, setIsModalOpenCadastrarMateriais] = useState(false);
  const modalCadastrarMateriais = () => {
    setIsModalOpenCadastrarMateriais(!isModalOpenCadastrarMateriais);


  };


  //---------------------------------------MODAL LANCAMENTO MATERIAL---------------------------------------------------//

  const [isModalOpenLancamentoMateriais, setIsModalOpenLancamentoMateriais] = useState(false);
  const modalLancamentoMateriais = () => {
    setIsModalOpenLancamentoMateriais(!isModalOpenLancamentoMateriais);


  };

  //---------------------------------------MODAL EDITAR LANCAMENTO MATERIAL---------------------------------------------------//
  const [editarLancamentos, setEditarLancamentos] = useState([])
  const [isModalOpenEditarLancamentoMateriais, setIsModalOpenEditarLancamentoMateriais] = useState(false);
  const modalEditarLancamentos = (item) => {
    setIsModalOpenEditarLancamentoMateriais(!isModalOpenEditarLancamentoMateriais);
    setEditarLancamentos(item);

  };


  //========================================================ENVIA O CODIGO/RECEBE A DESCRICAO

  const [codigoMaterial, setCodigoMaterial] = useState('');
  const [descricaoMaterial, setDescricaoMaterial] = useState('');


  const getMaterial = async (codigo) => {
    try {
      const response = await axios.get(`${urlApi}controle-reagentes/lancamento-material`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { codigoMaterial: codigo }
      });

      if (response.data.length > 0) {
        setDescricaoMaterial(response.data[0]);
      } else {
        toast.warn('Material não encontrado');
        setDescricaoMaterial({});
      }

    } catch (err) {
      console.log("Conexão falhou", err);
      toast.error('Erro ao buscar material');
      setDescricaoMaterial({});
    }
  };

  // Chama ao mudar o input e pressionar Enter ou sair do campo (onBlur)
  const handleBuscarMaterial = () => {
    if (codigoMaterial) {
      getMaterial(codigoMaterial);
    }
  };


  //---------------------------------------SELECIONA A DATA PARA BUSCAR OS LANÇAMENTOS---------------------------------------------------//

  const [dataIni, setDataIni] = useState('')
  const [dataFim, setDataFim] = useState('')
  const [listaLancamento, setListaLancamentos] = useState([]);
  const [showGrid, setShowGrid] = useState(false);
  const [showGrid2, setShowGrid2] = useState(false);
  const [atualizaLancamentos, setAtualizaLancamentos] = useState(false);

  const getListaLancamento = async () => {
    try {
      const res = await axios.get(`${urlApi}controle-reagentes/lista-lancamentos`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          data_ini: dataIni,
          data_fim: dataFim,
          ...(codigoMaterial && { cod_material: codigoMaterial }),
        }
      });

      setListaLancamentos(res.data);
      setShowGrid(true); // mostra o grid somente depois da busca
      setAtualizaLancamentos(false);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };




  useEffect(() => {
    getListaLancamento();
  }, [atualizaLancamentos]);



  const [listaSaldos, setListaSaldos] = useState([]);
  const [tipoSelecionado, setTipoSelecionado] = useState('')
  const getListaSaldos = async () => {
    try {
      const params = {
        // envia somente se tiver código
        cod_material: codigoMaterial?.trim() || undefined,

        // envia somente se não for '' nem null; preserva 0; converte para number
        tipo: (tipoSelecionado === '' || tipoSelecionado == null)
          ? undefined
          : Number(tipoSelecionado),
      };

      const res = await axios.get(`${urlApi}controle-reagentes/lista-saldos`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });

      setListaSaldos(res.data);
      setShowGrid2(true);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };




  const [listaConsumoMes, setListaConsumoMes] = useState([]);

  const getListaConsumoMes = async () => {
    try {
      const res = await axios.get(`${urlApi}controle-reagentes/lista-consumo-mes`, {
        headers: { Authorization: `Bearer ${token}` }

      });

      setListaConsumoMes(res.data);
    } catch (err) {
      console.log("Conexão falhou", err);
    }
  };

  useEffect(() => {
    getListaConsumoMes();
  }, []);






  return (
    <div style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden', width: '100vw', }}>

      {isModalOpenCadastrarMateriais && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalCadastrarMateriais();
              }}>
                <IoClose color={"red"} size={30} />
              </ButtonClose>
            </ButtonContainer>
            <Cadastrar
              urlApi={urlApi}
              subTipoMaterial={subTipoMaterial}
              tipoMaterial={tipoMaterial}
              setAtualizaMateriais={setAtualizaMateriais}

            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenEditarMateriais && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalEditarMateriais();
              }}>
                <IoClose color={"red"} size={30} />
              </ButtonClose>
            </ButtonContainer>
            <EditarMateriais
              urlApi={urlApi}
              subTipoMaterial={subTipoMaterial}
              tipoMaterial={tipoMaterial}
              setAtualizaMateriais={setAtualizaMateriais}
              editarMateriais={editarMateriais}
            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenLancamentoMateriais && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalLancamentoMateriais();
              }}>
                <IoClose color={"red"} size={30} />
              </ButtonClose>
            </ButtonContainer>
            <Lancamento
              urlApi={urlApi}
              setAtualizaMateriais={setAtualizaMateriais}

            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenEditarLancamentoMateriais && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalEditarLancamentos();
              }}>
                <IoClose color={"red"} size={30} />
              </ButtonClose>
            </ButtonContainer>
            <EditarLancamento
              urlApi={urlApi}
              editarLancamentos={editarLancamentos}
              setAtualizaLancamentos={setAtualizaLancamentos}
            />
          </ModalContent>
        </ModalContainer>
      )}

      {loadingImage || abaAtiva === "" ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100%",
            textAlign: "center",
          }}
        >
          <img
            src={loadingImage}
            alt="Carregando..."
            style={{
              width: 600,
              height: "auto",
              animation: "zoomIn 0.8s ease-out forwards",
            }}
          />
          <style>
            {`
                  @keyframes zoomIn {
                    from {
                      opacity: 0;
                      transform: scale(0.8);
                    }
                    to {
                      opacity: 1;
                      transform: scale(1);
                    }
                  }
                `}
          </style>
        </div>
      ) : (
        <Div>
          <DivLayout>
            <Title>
              <Title2>
                <DivTitle>

                  <DivTitle>
                    <ButtonSair onClick={handleVoltarDash} title="Voltar">
                      <IoMdArrowBack />
                    </ButtonSair>
                    <h2>Controle de Reagentes</h2>

                  </DivTitle>
                </DivTitle>

              </Title2>

            </Title>

            <DivButtom>
              <Title2>

                <DivTitle>
                  <Button

                    onClick={modalLancamentoMateriais}
                  >
                    Novo Lançamento
                  </Button>

                  <Button
                    active={abaAtiva === "consumo"}
                    onClick={() => setAbaAtiva("consumo")}
                  >
                    Consumo Mês
                  </Button>


                  <Button
                    active={abaAtiva === "saldos"}
                    onClick={() => setAbaAtiva("saldos")}
                  >
                    Saldos
                  </Button>

                  <Button
                    active={abaAtiva === "lancamentos"}
                    onClick={() => setAbaAtiva("lancamentos")}
                  >
                    Movimentações
                  </Button>

                  <Button
                    active={abaAtiva === "cadastrar"}
                    onClick={() => setAbaAtiva("cadastrar")}
                  >
                    Cadastrar
                  </Button>


                </DivTitle>

              </Title2>

            </DivButtom>
          </DivLayout>



          <Container>
            {abaAtiva === "consumo" && (
              <>

                <ListaConsumoMes
                  showMateriais={showMateriais}
                  listaConsumoMes={listaConsumoMes}
                  tipoMaterial={tipoMaterial}
                />
              </>
            )}

            {abaAtiva === "cadastrar" && (
              <ListaMateriais
                urlApi={urlApi}
                listaMateriais={listaMateriais}
                modalCadastrarMateriais={modalCadastrarMateriais}
                modalEditarMateriais={modalEditarMateriais}
                setAtualizaMateriais={setAtualizaMateriais}
                tipoMaterial={tipoMaterial}
                showMateriais={showMateriais}
                onVerMateriais={getListaMateriais}
              />
            )}

            {abaAtiva === "lancamentos" && (

              <>
                <Div2 >
                  <h2>Movimentações:</h2>
                  <Div3>
                    <Label>
                      Código do Material:
                      <Input1
                        type="text"
                        value={codigoMaterial}
                        onChange={(e) => setCodigoMaterial(e.target.value)}
                        onBlur={handleBuscarMaterial}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') handleBuscarMaterial();
                        }}
                        placeholder="Digite o código"
                      />
                    </Label>

                    {/* Exibe a descrição do material */}
                    <Label>
                      Descrição:
                      <Input2
                        type="text"
                        value={`${descricaoMaterial.DESC_MATERIAL || ''} `}
                        disabled={(!codigoMaterial)}
                        readOnly
                      />

                    </Label>
                    <Input
                      type="date"

                      value={dataIni}
                      onChange={(e) => setDataIni(e.target.value)}
                    />
                    <Input
                      type="date"

                      value={dataFim}
                      onChange={(e) => setDataFim(e.target.value)}
                    />
                    <ActionButton onClick={getListaLancamento}> <FaSearch /> Buscar</ActionButton>
                  </Div3>
                  <ListaLancamentos
                    urlApi={urlApi}
                    modalLancamentoMateriais={modalLancamentoMateriais}
                    modalEditarLancamentos={modalEditarLancamentos}
                    setAtualizaLancamentos={setAtualizaLancamentos}
                    tipoMaterial={tipoMaterial}
                    showGrid={showGrid}
                    listaLancamento={listaLancamento}
                  />
                </Div2>
              </>
            )}

            {abaAtiva === "saldos" && (

              <>
                <Div2 >
                  <h2>Saldos:</h2>
                  <Div3>
                    <Label>
                      Código do Material:
                      <Input1
                        type="text"
                        value={codigoMaterial}
                        onChange={(e) => setCodigoMaterial(e.target.value)}
                        onBlur={handleBuscarMaterial}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') handleBuscarMaterial();
                        }}
                        placeholder="Digite o código"
                      />
                    </Label>

                    {/* Exibe a descrição do material */}
                    <Label>
                      Descrição:
                      <Input2
                        type="text"
                        value={`${descricaoMaterial.DESC_MATERIAL || ''} `}
                        disabled={(!codigoMaterial)}
                        readOnly
                      />

                    </Label>
                    <Select
                      value={tipoSelecionado}
                      onChange={(e) => setTipoSelecionado(e.target.value)}
                    >
                      <option value="">Todos os tipos</option>
                      {tipoMaterial.map((tipo) => (
                        <option key={tipo.COD_TIPO} value={tipo.COD_TIPO}>
                          {tipo.DESC_TIPO}
                        </option>
                      ))}
                    </Select>

                    <ActionButton onClick={getListaSaldos}> <FaSearch /> Buscar</ActionButton>
                  </Div3>

                  <ListaSaldos
                    tipoMaterial={tipoMaterial}
                    showGrid2={showGrid2}
                    listaSaldos={listaSaldos}
                  />
                </Div2>
              </>
            )}
          </Container>

          <div>
            <ToastContainer
              autoClose={2500}
              position={toast.POSITION.BOTTOM_LEFT}
              style={{ width: '400px', fontSize: '22px' }}
            />

          </div>
        </Div>
      )}
      <GlobalStyle />
    </div>
  );
}

export default Usuarios;
